import { DrinkActivitySummary } from "../drinkService";

type DrinkExportRow = {
    drinkName: string;
    amount: string;
    consumedAt: string | null;
    startedAt: string | null;
    eventId: number | null;
};

const toExportRows = (activities: DrinkActivitySummary[]): DrinkExportRow[] => activities.map((activity) => ({
    drinkName: activity.drinkName,
    amount: `${activity.amountMl} ml`,
    consumedAt: activity.timestamp?.toISOString() ?? null,
    startedAt: activity.startedAt?.toISOString() ?? null,
    eventId: activity.eventId,
}));

const protectCsvCell = (value: string): string => {
    const safeValue = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
    return `"${safeValue.replace(/"/g, '""')}"`;
};

export const buildDrinksCsv = (activities: DrinkActivitySummary[]): string => {
    const rows = toExportRows(activities);
    return [
        ["drinkName", "amount", "consumedAt", "startedAt", "eventId"],
        ...rows.map((row) => [row.drinkName, row.amount, row.consumedAt ?? "", row.startedAt ?? "", row.eventId?.toString() ?? ""]),
    ].map((row) => row.map(protectCsvCell).join(",")).join("\r\n");
};

export const buildDrinksJson = (activities: DrinkActivitySummary[]): string => JSON.stringify(toExportRows(activities), null, 2);
